import { parse } from 'query-string';
import { CASE_AMENDING_TOGGLES, jobNames } from './../helpers';
import {
  LOCATION_CHANGE,
  SELECT_PERFORMANCE_JOB,
  RESET_PERFORMANCE_PAGE
} from './../actions';

const initialState = {
  jobBenchmarkPerformanceInfo: {
    toggles: 15,
    buildFilter: '',
    snPartI: '',
    snPartII: '',
    givenJob: '',
    dispatcherId: 0,
    jobName: jobNames.JOBBENCHMARK
  },
  selectedJobs: []
};

const jobBenchmarkPerformancePage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_PERFORMANCE_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case RESET_PERFORMANCE_PAGE:
      return initialState;
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        action.payload.pathname !== '/job-benchmark-performance') {
        return state;
      }

      // These are for the main selector:
      // t: build type bit representation
      // f: build filter
      // b: selected job type
      // i: selected casename
      // j: given job number, used to highlight a job coming from another page
      // d: id for selected dispatcher
      // The names need to be short because they're part of the URL query.
      const { f, b, i, t, j, d } = parse(action.payload.search);

      const parseJobBenchmarkPerformanceInfo = (
        toggles,
        buildFilter,
        jobType,
        caseName,
        givenJob,
        dispatcher,
        metricInfo,
      ) => {
        const parsedToggles = parseInt(toggles);
        const parsedGivenJob = parseInt(j);
        const parsedDispatcher = parseInt(dispatcher);

        return {
          toggles: (parsedToggles < 0) || (parsedToggles > 15) || isNaN(parsedToggles) ?
            metricInfo.toggles :
            parsedToggles,
          buildFilter: buildFilter ? buildFilter : '',
          snPartI: jobType ? jobType : '',
          snPartII: caseName ? caseName : '',
          givenJob: (parsedGivenJob < 0) || isNaN(parsedGivenJob) ?
            metricInfo.givenJob :
            parsedGivenJob,
          dispatcherId: (parsedDispatcher < 0) || isNaN(parsedDispatcher) ?
            0 :
            parsedDispatcher,
          jobName: metricInfo.jobName
        };
      };

      const parsedInfo =
        parseJobBenchmarkPerformanceInfo(
          t, f, b, i, j, d, state.jobBenchmarkPerformanceInfo);
      return {
        ...state,
        jobBenchmarkPerformanceInfo: parsedInfo,
        selectedJobs: parsedInfo.givenJob ?
          [{ value: `${parsedInfo.givenJob}` }] :
          []
      };

    default:
      return state;
  }
};

export default jobBenchmarkPerformancePage;

const getJobBenchmarkPerformancePage = state => state.jobBenchmarkPerformancePage;
export const getJobBenchmarkPerformanceInfo = state =>
  getJobBenchmarkPerformancePage(state).jobBenchmarkPerformanceInfo ||
  initialState.jobBenchmarkPerformanceInfo;
export const getJobBenchmarkPerformanceOutliersShown = state =>
  getJobBenchmarkPerformancePage(state).toggles & CASE_AMENDING_TOGGLES.OUTLIER;
export const getJobBenchmarkPerformanceSelectedJobs = state =>
  getJobBenchmarkPerformancePage(state).selectedJobs;



// WEBPACK FOOTER //
// src/reducers/jobBenchmarkPerformancePage.js